import { NDAModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<NDAModel>('/ipad/children/nda');
export default api;
